import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./sass/main.scss";
import axios from 'axios'
import VueAxios from 'vue-axios'
import ApiService from "./api.service";
import { createI18n } from "@/i18n/index";
import Toasted from 'vue-toasted';
import CKEditor from "@ckeditor/ckeditor5-vue2";
Vue.use(Toasted);
Vue.use(CKEditor);

const i18n = createI18n(store.state.translation.locale).i18n;
Vue.config.productionTip = false;
ApiService.init();
export const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  axios,
  VueAxios,
  render: (h) => h(App),
}).$mount("#app");
